// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.do-list-task {
    border: none;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 10px;
    font-size: 1rem;
    cursor: pointer;
    background-color: white;
    padding: 5px 10px;
    transition: background-color 300ms;
    border-radius: 8px;
    width: 100%;
}
.do-list-checkbox {
    width: 22px;
    height: 22px;
}
.do-list-task-container {
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 5px;
    font-size: 1rem;
    cursor: pointer;
    background-color: white;
    padding: 5px 10px;
    transition: background-color 300ms;
    border-radius: 8px;
    width: 30vw;
}
.do-list-task-header {
    font-weight: 500;
}
.do-list-task-subtitle {
    font-weight: 500;
}
.task-date-icon {
    width: 18px;
    height: 18px;
    vertical-align: top;
}
.task-date-container {
    display: flex;
    flex-direction: row;
    gap: 0.6rem;
    justify-content: center;
    align-items: center;
}
@media only screen and (max-width: 600px) {
    .do-list-task, .do-list-task-container {
        width: 100%;
    }
}
.do-list-task-header {
    font-size: 1rem;
    height: 10%;
}
@media (min-width:1281px) {
    /* hi-res laptops and desktops */
    .do-list-task, .do-list-task-container {
        width: 100%;
    }
    .do-list-subtitle {
        font-size: 1.4rem;
    }
    .do-list-task-header {
        font-size: 1.3rem;
        height: 10%;
    }
    .do-list-task-subtitle {
        font-size: 1.2rem;
        margin: 0;
        padding: 0;
        margin-bottom: 3px;
    }
    .do-list-checkbox {
        width: 29px;
        height: 29px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/task.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,gCAAgC;IAChC;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,SAAS;QACT,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".do-list-task {\n    border: none;\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    gap: 10px;\n    font-size: 1rem;\n    cursor: pointer;\n    background-color: white;\n    padding: 5px 10px;\n    transition: background-color 300ms;\n    border-radius: 8px;\n    width: 100%;\n}\n.do-list-checkbox {\n    width: 22px;\n    height: 22px;\n}\n.do-list-task-container {\n    border: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: start;\n    gap: 5px;\n    font-size: 1rem;\n    cursor: pointer;\n    background-color: white;\n    padding: 5px 10px;\n    transition: background-color 300ms;\n    border-radius: 8px;\n    width: 30vw;\n}\n.do-list-task-header {\n    font-weight: 500;\n}\n.do-list-task-subtitle {\n    font-weight: 500;\n}\n.task-date-icon {\n    width: 18px;\n    height: 18px;\n    vertical-align: top;\n}\n.task-date-container {\n    display: flex;\n    flex-direction: row;\n    gap: 0.6rem;\n    justify-content: center;\n    align-items: center;\n}\n@media only screen and (max-width: 600px) {\n    .do-list-task, .do-list-task-container {\n        width: 100%;\n    }\n}\n.do-list-task-header {\n    font-size: 1rem;\n    height: 10%;\n}\n@media (min-width:1281px) {\n    /* hi-res laptops and desktops */\n    .do-list-task, .do-list-task-container {\n        width: 100%;\n    }\n    .do-list-subtitle {\n        font-size: 1.4rem;\n    }\n    .do-list-task-header {\n        font-size: 1.3rem;\n        height: 10%;\n    }\n    .do-list-task-subtitle {\n        font-size: 1.2rem;\n        margin: 0;\n        padding: 0;\n        margin-bottom: 3px;\n    }\n    .do-list-checkbox {\n        width: 29px;\n        height: 29px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
